module.exports = __webpack_public_path__ + "img/feature_buy_th.262852f3.png";